import SectionBadge from "@/components/site/SectionBadge";

const ITEMS = [
  {
    quote:
      "They don't just deliver a strategy deck and disappear — they sit with the team through execution. That's the difference.",
    attribution: "Managing Director · Consumer Durables Company",
  },
  {
    quote:
      "In six months we saw the numbers move. Sharp diagnosis, disciplined execution, no fluff.",
    attribution: "Founder · D2C Brand",
  },
  {
    quote:
      "Brought a rare combination of strategic clarity and hands-on operating rigour.",
    attribution: "Chief Executive Officer · B2B Manufacturing Company",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-16 md:py-24 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="mb-12 md:mb-14 max-w-2xl">
          <SectionBadge label="Client Voice" />
          <h2 className="font-serif-display text-4xl sm:text-5xl mt-6 leading-[1.05]">
            What working with BLEZZINGS feels like.
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 reveal stagger-reveal">
          {ITEMS.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-[#F2F2F2] border border-black/5 p-8 md:p-10 flex flex-col justify-between"
            >
              <blockquote className="font-serif-display text-xl md:text-2xl leading-snug text-black">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-black/10">
                <div className="text-sm font-medium text-black">
                  {t.attribution}
                </div>
                <div className="text-xs text-zinc-500 mt-1">
                  Client identity withheld under confidentiality.
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
